import { gql } from '@apollo/client'

const imDfmSlidesPanelQuery = gql`
    query imDfmSlidesPanel($id: UUID!) {
        quoteModelRevision(id: $id) {
            id
            version
            dfmFeedback {
                id
                acceptedAt
                acceptedBy {
                    id
                    email
                }
                status
                attachment {
                    id
                }
                message
                title
                modelViewerSnapshots {
                    id
                    snapshot {
                        camera {
                            position
                            zoom
                            up
                            target
                        }
                        part {
                            transparent
                            patches {
                                color
                                hashcode
                            }
                        }
                        rotation
                        dfm {
                            color
                            threshold
                            feature
                            direction
                        }
                        annotations {
                            position
                        }
                        crossSection {
                            position
                            rotation
                        }
                        pointToPoint {
                            customPoints
                            selectedPoints {
                                index
                                type
                            }
                        }
                    }
                }
                sourceType
                status
                topic {
                    id
                    label
                }
            }
            quoteModel {
                selectedQuoteModelRevision {
                    id
                    version
                }
                quote {
                    isCpqOwned
                    type
                }
            }
        }
    }
`

export default imDfmSlidesPanelQuery
